import AreaContainer from "../AreaContainer";
import styles from './description.module.css'
import globalStyles from '../result.module.css'
import { useState } from "react";

interface Props {
    description: string;
    situation: string;
    locationDescription: string;
    headline: string;
    keyPoints: any;
    introduction: string;
    detailed_specifications: string;
    property: boolean;
}

const Description = ({ description, situation, locationDescription, headline, keyPoints, introduction, detailed_specifications, property = false }: Props) => {
    if (!description && !locationDescription && !headline && keyPoints.length == 0 && !introduction && !situation) return null;
    const descriptionFormat = description !== null ? description.split("\n") : null;
    const situationFormat = situation ? situation.split("\n") : null;
    const locationFormat = locationDescription ? locationDescription.split("\n") : null;
    const [showAllDecription, setShowAllDecription] = useState(true);

    return <AreaContainer area="description" style={null} extraClass={null}>
        {Array.isArray(keyPoints) && keyPoints.length > 0 &&
            <div className={!property ? `${styles.insideWrapper} ${styles.keyPointsWrapper}` : styles.keyPointsWrapper}>
                <h2 className={globalStyles.subTitleText}>Key Features</h2>
                <ul>
                    {keyPoints.map((point) => {
                        return <li key={point}><p className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{point}</p></li>
                    })}

                </ul>
            </div>
        }
        {(description || headline || introduction) && (
            <div className={styles.DescriptionWrapper}>
                <h2 className={globalStyles.subTitleText}>Description</h2>
                <div className={!property ? styles.insideWrapper : ''}>
                    {headline && <h2 className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} >{headline}</h2>}
                    {introduction && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`}>{introduction}</p>}

                    {Array.isArray(descriptionFormat) && descriptionFormat.length > 0 && <>
                        {descriptionFormat.slice(0, showAllDecription ? descriptionFormat.length : 3).map((para, index) => {
                            return <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} key={index}>{para}</p>
                        })}
                    </>}

                    {detailed_specifications && showAllDecription && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} dangerouslySetInnerHTML={{ __html: detailed_specifications }}></p>}

                </div>
            </div>
        )}
        {
            locationDescription && (
                <div className={styles.DescriptionWrapper}>
                    <h2 className={globalStyles.subTitleText}>Location</h2>
                    <div className={!property ? styles.insideWrapper : ''}>

                        {Array.isArray(locationFormat) && locationFormat.length > 0 && <>
                            {locationFormat.map((para, index) => {
                                return <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} key={index}>{para}</p>
                            })}
                        </>}
                    </div>
                </div>
            )
        }
        {
            situation && (
                <div className={styles.DescriptionWrapper}>
                    <h2 className={globalStyles.subTitleText}>Situation</h2>
                    <div className={!property ? styles.insideWrapper : ''}>

                        {Array.isArray(situationFormat) && situationFormat.length > 0 && <>
                            {situationFormat.map((para, index) => {
                                return <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText} ${globalStyles.largeLineHeight}`} key={index}>{para}</p>
                            })}
                        </>}
                    </div>
                </div>
            )
        }
    </AreaContainer>
};

export default Description;
